module.exports = __webpack_public_path__ + "static/img/Noise_XX.06ffda5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/handshakes/assets/Noise_XX.png
// module id = g9Xj
// module chunks = 1